import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import Input from "../../core/input";
import Icon from "../../core/icon";
import Button from "../../core/button";
import Tooltip from "../../core/tooltip";
import { positions, icons, sizes } from "../../../enums";
var ADDED_PROPS = ['isHidden', 'setIsHidden', 'hasKeyPressed', 'setHasKeyPressed', 'revealTooltipTextDisabled', 'revealTooltipTextActive', 'revealToggleTooltipPosition', 'handleHide'];
var MODIFIED_PROPS = ['action', 'type'];
var PasswordField = createComponent({
  displayName: 'PasswordFieldCmp',
  propTypes: {
    revealToggleTooltipPosition: PropTypes.oneOf(positions.LRTB),
    revealTooltipTextDisabled: PropTypes.string,
    revealTooltipTextActive: PropTypes.string,
    isUnderlined: PropTypes.bool,
    iconSize: PropTypes.oneOf(sizes.ALL)
  },
  defaultProps: {
    revealToggleTooltipPosition: positions.TOP,
    revealTooltipTextDisabled: undefined,
    revealTooltipTextActive: undefined,
    isUnderlined: false,
    iconSize: sizes.X5
  },
  state: {
    isHidden: true,
    hasKeyPressed: false
  },
  handlers: {
    handleHide: function handleHide(p) {
      return function (e) {
        p.setIsHidden(!p.isHidden);
        e.preventDefault();
      };
    },
    onKeyPress: function onKeyPress(p) {
      return function (e) {
        p.setHasKeyPressed(true);
      };
    }
  },
  render: function render(props) {
    var _cx = cx({
      'password-field': true
    });

    var inputProps = toUIProps({
      props: props,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });

    var _icon = /*#__PURE__*/React.createElement(Icon, {
      size: props.iconSize,
      name: props.isHidden ? icons.PREVIEW_OFF : icons.PREVIEW
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _cx
    }, /*#__PURE__*/React.createElement(Input, _extends({
      isFluid: true,
      action: /*#__PURE__*/React.createElement(Tooltip, {
        tooltip: props.hasKeyPressed ? props.revealTooltipTextActive : props.revealTooltipTextDisabled,
        position: props.revealToggleTooltipPosition
      }, /*#__PURE__*/React.createElement(Button.Secondary, {
        onClick: props.handleHide,
        icon: _icon,
        isDisabled: !props.hasKeyPressed
      })),
      type: props.isHidden ? 'password' : 'text',
      isUnderlined: props.isUnderlined,
      onKeyPress: props.onKeyPress
    }, inputProps)));
  }
});
export default PasswordField;
//# sourceMappingURL=index.js.map